import React, { useEffect, Fragment } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import { useLocation, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import PaymentService from "../../Api/services/PaymentService";

const Thankyoutripplanner = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  window.onpopstate = function (e) {
    console.log(e.state);
  };

  useEffect(() => {
    localStorage.removeItem("payment_status_trip");
    localStorage.removeItem("stripedatatrip");
    localStorage.removeItem("stripesessiontrip");
    localStorage.removeItem("stripedatatripprice");
    localStorage.removeItem("stripedatatriporderid");

    checkstatus();

    Cookies.set("Token", "value", { expires: 7 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, location?.state]);

  const pushTripPlannerPurchaseIfNotTracked = async ({
    transaction_id,
    value,
    payment_type,
    email,
  }) => {
    const tx = String(transaction_id || "");
    if (!tx) return;

    // backend de-dupe (your existing method)
    const statusData = await PaymentService.checkStatus({
      transaction_id: tx,
    }).json();

    if (statusData?.status !== "not_exists") {
      console.log("Trip Planner purchase already tracked.");
      return;
    }

    if (window[`_tracked_trip_${tx}`]) {
      console.log("Trip Planner purchase already tracked in memory.");
      return;
    }
    window[`_tracked_trip_${tx}`] = true;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "purchase_trip_planner",
      transaction_id: String(tx),
      value: Number(value || 0),
      currency: "EUR",
      product_type: "trip_planner",
      payment_type: String(payment_type || "cash"),
      
      // Consistency fields (empty for trip planner but kept for schema alignment)
      camper_model: "",
      start_date: "",
      end_date: ""
    });

    await PaymentService.storeEvent({
      transaction_id: tx,
      event_name: "purchase_trip_planner",
    }).json();
  };

  const checkstatus = async () => {
    // 1) STRIPE FLOW: /thankyou-tripplanner?id=xxxx
    const stripeSessionId = searchParams.get("id");

    if (stripeSessionId) {
      try {
        const p_service = await PaymentService.checkstripepayment(
          stripeSessionId
        ).json();

        if (p_service) {
          await pushTripPlannerPurchaseIfNotTracked({
            transaction_id: stripeSessionId, // keep same as your existing logic
            value: p_service.amount || p_service.price || 0,
            payment_type: "stripe",
            email: p_service.email || "",
          });
        }
      } catch (error) {
        console.error("Error checking trip planner (stripe) status:", error);
      }
      return;
    }

    // 2) CASH / PAYPAL FLOW: no ?id= -> use state/localStorage
    try {
      const state = location?.state || {};

      let orderId = state?.order_id;
      if (orderId) {
        localStorage.setItem("last_thankyou_trip_order", String(orderId));
      } else {
        orderId = localStorage.getItem("last_thankyou_trip_order");
      }
      if (!orderId) return;

      const saved = localStorage.getItem(`thankyou_trip_track_${orderId}`);
      if (!saved) return;

      const payload = JSON.parse(saved);

      await pushTripPlannerPurchaseIfNotTracked({
        transaction_id: payload.order_id,
        value: payload.total_price || 0,
        payment_type: payload.payment_type || "cash",
        email: payload.email || "",
      });
    } catch (error) {
      console.error("Error checking trip planner (cash/paypal) status:", error);
    }
  };

  return (
    <Fragment>
      <Header />
      <div className="min-h-screen bg-off-white">
        <div className="pb-5 text-center">
          <div className="overflow-hidden">
            <div className="-ml-[5%] w-[110%] overflow-hidden rounded-b-[60%20%] px-[5%]">
              <div className="relative">
                <div className="overflow-hidden">
                  <img
                    src="../Images/Thank you pages.jpg"
                    alt="hero-banner"
                    className="absolute max-h-full w-full scale-110 object-cover blur-lg dark:brightness-90 sm:aspect-hero-regular 3xl:aspect-hero-long aspect-square"
                  />
                </div>
                <picture className="flex max-h-[65vh] w-full text-0">
                  <img
                    className="z-0 max-h-full w-full object-cover dark:brightness-90 sm:aspect-hero-regular 3xl:aspect-hero-long aspect-square"
                    src="../Images/Thank you pages.jpg"
                    alt="hero-banner"
                    width="2552"
                    height="1286"
                  />
                </picture>
                <div className="absolute top-0 left-0 flex h-full w-full flex-col items-center justify-end">
                  <div className="pb-12 2xl:pb-14 w-full bg-gradient-to-t from-black-pure/80 to-transparent pt-20 md:pt-14 xl:pt-32">
                    <h1 className="whitespace-pre-line break-words m-auto max-w-4xl px-8 text-xl md:text-2xl text-white drop-shadow-text dark:text-off-white xs:text-2xl xl:text-3xl mb-5 md:mb-8 xl:mb-12">
                      {t("thankyou.Thank You")}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mx-5 max-w-screen-xl xl-padded:mx-auto">
          <div className="xl:pt-8 pt-3 2xl:pt-8 pb-8 2xl:pb-12 mx-auto flex max-w-4xl flex-col items-center text-center">
            <div className="inline-block align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark mb-4 child:h-20 child:w-20">
              <img src="../Images/img-aboutus-header-banner.svg" alt="aboutus-header-banner" />
            </div>
            {/* <p className="mb-4 whitespace-pre-line text-md">What we strive for</p> */}
            <h2 className="whitespace-pre-line break-words text-xl md:text-2xl mb-4">
              {t("thankyou.Thank you for your trust!")}
            </h2>
            <p className="mb-2 whitespace-pre-line text-2md font-normal md:text-lg-paragraph md:font-normal text-20">
              {t("thankyou.You can expect an email with your travel itinerary in the next few days.")}
            </p>
            <p className="mb-2 whitespace-pre-line text-2md font-normal md:text-lg-paragraph md:font-normal text-20">
              {t("thankyou.If you have any questions before then, don't hesitate to contact us!")}
            </p>
            <p className="mb-2 whitespace-pre-line text-2md font-normal md:text-lg-paragraph md:font-normal text-20">
              WhatsApp: +49 163 2937354
            </p>
            {/* <p className="mb-2 whitespace-pre-line text-2md font-normal md:text-lg-paragraph md:font-normal text-20">
            {t("thankyou.Go To")} <Link className="w-full text-center hover:text-primary hover:dark:text-primary-light mb-2 last:mb-0" to={'/'}>{t("thankyou.Home")}</Link>
            </p> */}
          </div>
        </div>
      </div>
      <Footer />
    </Fragment>
  );
};

export default Thankyoutripplanner;